document.addEventListener("DOMContentLoaded", function () {

  const root = document.querySelector(".collection-partbar");
  if (!root) {
    console.log("NO PARTBAR ROOT");
    return;
  }

  const list = root.querySelector(".collection-partbar__list");
  const btn = root.querySelector(".collection-partbar__btn");
  const btnLabel = root.querySelector(".collection-partbar__btn-label");

  if (!btn || !list) {
    console.log("PARTBAR INIT FAILED");
    return;
  }

  // OPEN / CLOSE
  btn.addEventListener("click", function (e) {
    e.preventDefault();
    root.classList.toggle("is-open");
  });

  document.addEventListener("click", function (e) {
    if (!root.contains(e.target)) {
      root.classList.remove("is-open");
    }
  });

  // CLICK PART → REDIRECT TO SHOPIFY FILTER
  list.addEventListener("click", function (e) {

    const el = e.target.closest("[data-part]");
    if (!el) return;

    e.preventDefault();

    const part = el.dataset.part;

    console.log("REDIRECT TO PART:", part);

    const baseUrl = window.theme.collection.url;

    if (!part) {
      window.location.href = baseUrl;
    } else {
      window.location.href = baseUrl + "/part_" + part.toLowerCase();
    }

  });

});